import createRouter5 from 'router5'
import browserPlugin from 'router5-plugin-browser';

import {routes, ROOT, LISTS, CODE, ERROR} from './routes';

export const createRouter = () => {
    const router = createRouter5(routes, {
        defaultRoute: ROOT
    })

    const canActivateLists = () => (_toState, fromState) => {
        return fromState !== null && fromState.name === CODE;
    }
    const canActivateCode = () => (_toState, fromState) => {
        return fromState !== null && [ROOT, LISTS, ERROR].includes(fromState.name);
    }
    const canActivateError = () => (_toState, fromState) => {
        return fromState !== null && fromState.name === CODE;
    }
    router.canActivate(LISTS, canActivateLists)
    router.canActivate(CODE, canActivateCode)
    router.canActivate(ERROR, canActivateError)

    router.usePlugin(browserPlugin())

    return router
}